import { CodeMasterSearchParam } from "../types/WebData";
import API from "./api";
import * as MESSAGE from "../const/message";

/**
 * codemasterテーブルAPI
 * コード情報検索
 *
 * @param {CodeMasterSearchParam} searchParam
 * @return {*} 
 */
export const postSearchCodemaster = async (searchParam: CodeMasterSearchParam) => {
  const result = await API.post(`/cms-api/codemaster/search`, searchParam)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return { isError: true, message: MESSAGE.SYSTEM_ERROR, data: [] };
    });

  return result;
};